export default "__VITE_ASSET__BKKvORXm__"